// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".listing-filter-buttons{display:flex;overflow-x:scroll}@media(min-width:1024px){.listing-filter-buttons{flex-wrap:wrap;overflow-x:visible;overflow-x:initial}.listing-filter-buttons__button{margin:0 0 8px}}.listing-filter-buttons__button:not(:last-child){margin-right:var(--spacing-smaller)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
